module.exports = __webpack_public_path__ + "img/marker-shadow.6237fa29.png";